import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Facebook, MapPin } from "lucide-react";
import { CONTACT } from "@/lib/data";

export default function Footer() {
  return (
    <footer className="relative mt-32 bg-ocean text-white overflow-hidden" data-testid="footer">
      {/* Decorative shapes */}
      <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-coral/20 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-20 w-96 h-96 rounded-full bg-lagoon/15 blur-3xl pointer-events-none" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2 max-w-md">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-14 h-14 rounded-2xl bg-white flex items-center justify-center p-2">
              <img src="/logo-ssp.png" alt="Logo SSP" className="w-full h-full object-contain" />
            </div>
            <div>
              <div className="font-display text-xl">Soutien Scolaire Papara</div>
              <div className="text-xs uppercase tracking-[0.2em] text-coral">De la maternelle au collège</div>
            </div>
          </div>
          <p className="text-white/70 text-sm leading-relaxed">
            Un accompagnement scolaire bienveillant et professionnel pour les enfants de Papara et Mataiea.
            Soutien quotidien, ramassage scolaire, stages de vacances et activités éveillantes.
          </p>
        </div>

        <div>
          <h4 className="font-display text-lg mb-4 text-coral">Navigation</h4>
          <ul className="space-y-2 text-sm text-white/75">
            <li><Link to="/" className="hover:text-coral transition-colors">Accueil</Link></li>
            <li><Link to="/le-centre" className="hover:text-coral transition-colors">Le Centre</Link></li>
            <li><Link to="/services" className="hover:text-coral transition-colors">Services</Link></li>
            <li><Link to="/tarifs" className="hover:text-coral transition-colors">Tarifs</Link></li>
            <li><Link to="/inscription" className="hover:text-coral transition-colors">Inscription</Link></li>
            <li><Link to="/contact" className="hover:text-coral transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-4 text-coral">Contact</h4>
          <ul className="space-y-3 text-sm text-white/75">
            <li className="flex items-start gap-2">
              <Phone size={16} className="mt-1 text-coral shrink-0" />
              <a href={`tel:${CONTACT.phoneRaw}`} className="hover:text-coral">{CONTACT.phone}</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail size={16} className="mt-1 text-coral shrink-0" />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-coral break-all">{CONTACT.email}</a>
            </li>
            <li className="flex items-start gap-2">
              <Facebook size={16} className="mt-1 text-coral shrink-0" />
              <a href={CONTACT.facebook} target="_blank" rel="noreferrer" className="hover:text-coral">{CONTACT.facebookLabel}</a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={16} className="mt-1 text-coral shrink-0" />
              <span>{CONTACT.adresse}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/50">
          <span>© {new Date().getFullYear()} Soutien Scolaire Papara — Tous droits réservés.</span>
          <Link to="/admin/login" className="hover:text-coral" data-testid="footer-admin-link">Espace administrateur</Link>
        </div>
      </div>
    </footer>
  );
}
